<script>
import { Collapse } from 'vue-collapsed';
// import { Swiper, SwiperSlide } from 'swiper/vue';
import Media from '@/components/elements/Media.vue';
// import VideoEmbed from '@/components/elements/VideoEmbed.vue';
// import Carousel from '@/components/modules/Carousel.vue';

export default {
    name: 'Accordion',
    props: {
        isDefaultOpen: {
            type: String,
            default: 'false'
        }
    },
    data() {
        return {
            isOpen: this.isDefaultOpen === 'true'
        }
    },
    computed: {
        triggerId () {
            return `accordion-${this.$.uid}-trigger`
        },
        drawerId () {
            return `accordion-${this.$.uid}-drawer`
        },
        triggerAttrs () {
            return {
                'id': this.triggerId,
                'class': {
                    'state-open': this.isOpen
                },
                'aria-controls': this.drawerId,
                'aria-expanded': this.isOpen
            }
        },
        drawerAttrs () {
            return {
                'id': this.drawerId,
                'role': 'region',
                'aria-labelledby': this.triggerId
            }
        }
    },
    methods: {
        triggerClick () {
            this.isOpen = !this.isOpen;
        }
    },
    components: {
        Collapse,
        Media,
        // VideoEmbed,
        // Carousel,
        // Swiper,
        // SwiperSlide
    }
};
</script>